import {Injectable} from '@angular/core';

/**
 * A file to import into a project as soon as the map opens it.
 *
 * "New project from an .mmp file" makes the project on the dashboard, which
 * has no import of its own; the map then brings the file in through the
 * import every other file goes through (ProjectService.loadFiles), pictures
 * and layers included. Kept in memory only: a reload before the project opens
 * leaves it empty, as a new project is.
 */
@Injectable({
  providedIn: 'root'
})
export class PendingImportService {
  private pending: {projectId: string, file: File} | null = null;

  set(projectId: string, file: File) {
    this.pending = {projectId, file};
  }

  /** The file waiting for this project, once: it is forgotten as it is handed over. */
  take(projectId: string): File | null {
    if (!this.pending || this.pending.projectId !== projectId) {
      return null;
    }
    const file = this.pending.file;
    this.pending = null;
    return file;
  }
}
